__turbopack_context__.v({
  "accordionSlideOverwrite": "chipNavigator-module-scss-module__nDAhya__accordionSlideOverwrite",
  "chipNavigator": "chipNavigator-module-scss-module__nDAhya__chipNavigator",
  "dropdown": "chipNavigator-module-scss-module__nDAhya__dropdown",
  "fadeIn": "chipNavigator-module-scss-module__nDAhya__fadeIn",
  "fadeOut": "chipNavigator-module-scss-module__nDAhya__fadeOut",
  "scaleIn": "chipNavigator-module-scss-module__nDAhya__scaleIn",
  "scaleOut": "chipNavigator-module-scss-module__nDAhya__scaleOut",
  "selected": "chipNavigator-module-scss-module__nDAhya__selected",
  "zoomIn": "chipNavigator-module-scss-module__nDAhya__zoomIn",
  "zoomOut": "chipNavigator-module-scss-module__nDAhya__zoomOut",
});
